import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { WishlistResponse } from '@/types/api/api-v2';
import { BaseApiResponse } from '@/types/api/api-v2';

export default async function getWishlist(): Promise<WishlistResponse> {
  try {
    const {
      data: { data },
    } =
      await spiritoryWebApi.get<BaseApiResponse<WishlistResponse>>('/wishlist');

    return data;
  } catch (error: unknown) {
    console.error(error);
    return {
      wishlist: {
        userId: '',
        createdAt: '',
        updatedAt: '',
        skus: [],
      },
      pagination: {
        total: 0,
        totalPages: 0,
        currentPage: 0,
        perPage: 0,
      },
    };
  }
}
